import { type FC } from 'react';

/** Open book — section title only. */
export const MethodSpecsBookIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M10 5.8335V17.5002"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.49996 15C2.03972 15 1.66663 14.6269 1.66663 14.1667V3.33333C1.66663 2.8731 2.03972 2.5 2.49996 2.5H6.66663C8.50758 2.5 9.99996 3.99238 9.99996 5.83333C9.99996 3.99238 11.4923 2.5 13.3333 2.5H17.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333V14.1667C18.3333 14.6269 17.9602 15 17.5 15H12.5C11.1192 15 9.99996 16.1193 9.99996 17.5C9.99996 16.1193 8.88067 15 7.49996 15H2.49996"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Card (Gateway) — payment card outline. */
export const MethodSpecsGatewayCardIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M3.33329 4.1665H16.6666C17.5871 4.1665 18.3333 4.9127 18.3333 5.83317V14.1665C18.3333 15.087 17.5871 15.8332 16.6666 15.8332H3.33329C2.41282 15.8332 1.66663 15.087 1.66663 14.1665V5.83317C1.66663 4.9127 2.41282 4.1665 3.33329 4.1665V4.1665"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66663 8.3335H18.3333"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Card H2H — stacked blocks. */
export const MethodSpecsH2HIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M3.33329 1.6665H16.6666C17.5871 1.6665 18.3333 2.4127 18.3333 3.33317V6.6665C18.3333 7.58698 17.5871 8.33317 16.6666 8.33317H3.33329C2.41282 8.33317 1.66663 7.58698 1.66663 6.6665V3.33317C1.66663 2.4127 2.41282 1.6665 3.33329 1.6665V1.6665"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33329 11.6665H16.6666C17.5871 11.6665 18.3333 12.4127 18.3333 13.3332V16.6665C18.3333 17.587 17.5871 18.3332 16.6666 18.3332H3.33329C2.41282 18.3332 1.66663 17.587 1.66663 16.6665V13.3332C1.66663 12.4127 2.41282 11.6665 3.33329 11.6665V11.6665"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5 5H5.00833" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 15H5.00833" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** P2P — people. */
export const MethodSpecsP2PIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M13.3334 17.5V15.8333C13.3334 13.9924 11.841 12.5 10 12.5H5.00002C3.15907 12.5 1.66669 13.9924 1.66669 15.8333V17.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 2.60645C14.8035 2.98758 15.8301 4.31434 15.8301 5.83311C15.8301 7.35189 14.8035 8.67864 13.3333 9.05978"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 17.5001V15.8334C18.3322 14.3143 17.3041 12.9882 15.8333 12.6084"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16669 5.83333C4.16669 7.67305 5.6603 9.16667 7.50002 9.16667C9.33974 9.16667 10.8334 7.67305 10.8334 5.83333C10.8334 3.99362 9.33974 2.5 7.50002 2.5C5.6603 2.5 4.16669 3.99362 4.16669 5.83333V5.83333"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** APM — wallet. */
export const MethodSpecsWalletIcon: FC = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M15.8333 5.83333V3.33333C15.8333 2.8731 15.4602 2.5 15 2.5H4.16667C3.24681 2.5 2.5 3.24681 2.5 4.16667C2.5 5.08652 3.24681 5.83333 4.16667 5.83333H16.6667C17.1269 5.83333 17.5 6.20643 17.5 6.66667V10H15C14.0801 10 13.3333 10.7468 13.3333 11.6667C13.3333 12.5865 14.0801 13.3333 15 13.3333H17.5C17.9602 13.3333 18.3333 12.9602 18.3333 12.5V10.8333C18.3333 10.3731 17.9602 10 17.5 10"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 4.1665V15.8332C2.5 16.7536 3.24619 17.4998 4.16667 17.4998H16.6667C17.1269 17.4998 17.5 17.1267 17.5 16.6665V13.3332"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
